// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /pickem/results-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typePickemResultsGetBody,
  typePickemResultsGetOutput200,
} from "../../sdk/pickem/postPickemResultsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildPickemResultsGetQueryKey(
  payload: typePickemResultsGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  if (typeof payload.roundId !== "undefined") {
    queryKeySegments.push(`roundId:${JSON.stringify(payload.roundId)}`);
  }
  if (typeof payload.userId !== "undefined") {
    queryKeySegments.push(`userId:${JSON.stringify(payload.userId)}`);
  }
  return [
    "post:pickem:pickemResultsGet",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typePickemResultsGetOutput200,
    unknown,
    typePickemResultsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function usePickemResultsGet(
  payload: typePickemResultsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildPickemResultsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postPickemResultsGet(payload),
    ...resolvedOptions,
  });
}
